import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RmtCardInformationGroup } from '../../model/models/wallet/wallet';

@Component({
    selector: 'rmt-card-transaction',
    templateUrl: 'rmt-card-transaction.html'
})

export class RmtCardTransactionComponent {
    @Input() groupHeader: string;
    @Input() headerIcon: string;
    @Input() internationalCurrency: string;
    @Output() buttonPressedEmitter: EventEmitter<any> = new EventEmitter();

    @Input() fontSizeClassName: string;
    @Input() informationGroup:Array<RmtCardInformationGroup> = [];
    @Output() transOnClickEvent: EventEmitter<any> = new EventEmitter();

    rowLableTextCss: string = 'rmt-font leftItemFont align-left';
    rowValueTextCss: string = 'rmt-font semibold rightItemFont align-right';
    constructor() {
    }

    ionViewWillEnter(){
        this.rowLableTextCss += (this.fontSizeClassName ? this.fontSizeClassName : ' Body2')
        this.rowValueTextCss += (this.fontSizeClassName ? this.fontSizeClassName : ' Body2')
    }

    getLeftColClass(item: any): string {
        if (item.lastItem) return 'bold-item';
        if (item.limitsItemHeader) return 'H3 bold item-limits-header';
        if (item.limitsItem || item.singleLineText) return 'item-limits regular-600';
        return 'Body2';
    }

    getRightColClass(item: any): string {
        if (item.lastItem) return 'bold-item';
        if (item.limitsItemHeader) return 'Caption content';
        if (item.limitsItem) return 'item-limits-right';
        return 'bold';
    }

    getRightSpanClass(item: any): string {
        return item.limitsItemHeader ? 'item-limits-header-right bold' : '';
    }

    onActionPressed() {
        this.buttonPressedEmitter.emit();
    }

    onClickEvent(item: RmtCardInformationGroup,type: string){
        this.transOnClickEvent.emit({item: item ,type: type});
    }
}


// WEBPACK FOOTER //
// ./src/components/rmt-card-transaction/rmt-card-transaction.ts